export default __webpack_public_path__ + "images/JU.1e64b01.png";